module.exports = {"FelineQueen":"fq"}


//////////////////
// WEBPACK FOOTER
// ./config/themes.yaml
// module id = 28
// module chunks = b-loader